import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// E88cash Firebase 專案
const firebaseConfig = {
  apiKey: "AIzaSyDwNEYVRozcshypNGIOinUToWMVXbj0y2E",
  authDomain: "e88cash.firebaseapp.com",
  projectId: "e88cash",
  storageBucket: "e88cash.firebasestorage.app",
  messagingSenderId: "439297410474",
  appId: "1:439297410474:web:dfe91b7c72977a806957d3",
  measurementId: "G-9GC9DBD7XQ"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics };
